<template>
    <div class="question">
        <div class="top">
            <span>{{questionType.typeDisplay}}</span>
        </div>
        <div class="main bg-fff">
            <div v-for="(q,index) in questionType.helpCenterDetailsList" class="q-item">
                <p class="q-name">{{index+1}}、Q：{{q.name}}</p>
                <div class="q-answer">
                    A：
                    <span v-html="q.content" class="ql-editor"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../../api'
    import config from '../../../config/config'
    export default {
        data() {
            return {
                questionType: {}
            }
        },
        methods: {
            getQuestions(){
                api.questions.getQuestions({
                    type: this.$route.params.type,
                    channel: config.isZhulogic ? 'zhulogic' : 'other',
                })
                    .then(res => {
                        this.questionType = res[0]
                    })
            }
        },
        watch: {
            '$route': function (to, from) {
                this.getQuestions();
            }
        },
        created(){
            this.getQuestions();
        }
    }
</script>
<style scoped type="text/scss" lang="scss">
    .question {
        margin-top: -1px;
        .main {
            width: 974px;
            font-size: 14px;
            float: left;
            color: #353838;
            margin-top: 20px;
            padding: 0 40px;
            padding-bottom: 200px;
            line-height: 26px;
            letter-spacing: 1px;
        }
        .top {
            border-bottom: 2px solid #F2F4F5;
            span {
                font-size: 20px;
                color: #353838;
                padding: 0 40px;
            }
        }
    }
    .q-item{
        margin-top:30px;
        .q-name{
            font-size: 13px;
            color: #353838;
            font-weight: 600;
        }
        .q-answer{
            font-size: 14px;
            color: #6C6F70;
            padding:0 28px;
            margin-top:4px;
            .ql-editor{
                display:inline-block;
                padding:0;
                vertical-align: text-top;
                width: 96%;
                p{
                    font-size: 14px;
                }
            }
        }
    }
</style>
